import type { TimestampInMillis } from './dates';
import type { UUID } from './identifier';

export const EVENTS_REQUEST_AMOUNT = 20;

export enum EventTypes {
  GEOFENCE_IN = 'geofence_in',
  GEOFENCE_OUT = 'geofence_out',
  SPEED_LIMIT = 'speed_limit',
  VEHICLE_SPEED_LIMIT = 'vehicle_speed_limit',
}

export enum ReducedEventTypes {
  SPEED_LIMIT = 'SPEED_LIMIT',
  GEOFENCE = 'GEOFENCE',
}

interface GenericEvents {
  id: UUID;
  date: TimestampInMillis;
  deviceId: UUID;
  licensePlate: string;
  driverId?: UUID;
  driverName?: string;
}

interface GeofenceEvents extends GenericEvents {
  type: ReducedEventTypes.GEOFENCE;
  geofenceId: UUID;
  geofenceName?: string;
  latitude: number;
  longitude: number;
}

interface EntryGeofenceEvents extends GeofenceEvents {
  geoType: EventTypes.GEOFENCE_IN;
}

interface ExitGeofenceEvents extends GeofenceEvents {
  geoType: EventTypes.GEOFENCE_OUT;
}

interface GenericSpeedLimitEvents extends GenericEvents {
  type: ReducedEventTypes.SPEED_LIMIT;
  speedInKmH: number;
  latitude: number;
  longitude: number;
  durationAboveSpeedLimit?: number;
}

interface SpeedLimitEvents extends GenericSpeedLimitEvents {
  speedLimitType: EventTypes.SPEED_LIMIT;
  roadSpeedLimitInKmH: number;
}

interface VehicleSpeedLimitEvents extends GenericSpeedLimitEvents {
  speedLimitType: EventTypes.VEHICLE_SPEED_LIMIT;
  vehicleSpeedLimitInKmH: number;
}

export type EventsWithLatLng = EntryGeofenceEvents | ExitGeofenceEvents | SpeedLimitEvents | VehicleSpeedLimitEvents;
export type Events = EventsWithLatLng & { address: string };
